<template>
  <div id="error-layout">
    <img
      src="@/assets/images/element/zeste.svg"
      alt="Yuzu zeste"
      class="zeste"
    />
    <img
      src="@/assets/images/element/dots-pattern.svg"
      alt="Yuzu dots pattern"
      class="dots-pattern"
    />
    <img
      src="@/assets/images/element/dots-pattern.svg"
      alt="Yuzu dots pattern"
      class="dots-pattern-2"
    />
    <img
      src="/images/defaults/space/lemon-yellow.svg"
      alt="Yuzu lemon"
      class="lemon-bg"
    />
    <main>
      <router-view v-slot="{ Component, route }">
        <transition mode="out-in" name="fade">
          <component :is="Component" :id="route.name" />
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script setup>
import { useDark } from "@vueuse/core";

const isDark = useDark();
</script>
